var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"data":{
			name: 'Clients Import',
			breadcrumbs: [
				{ name: 'Home', to: '/' },
				{ name: 'Client Contacts', to: '/client-contacts' } ],
		}}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('LPDataImporter',{attrs:{"tableName":'client_contacts'}})],1)])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }